import { defineStore, StoreDefinition } from 'pinia';
import initialState from './state.js';
import actions from './actions.js';
import getters from './getters.js';

export const useGlobalStore: StoreDefinition<
    'global',
    typeof initialState,
    typeof getters,
    typeof actions
> = defineStore('global', {
    state() {
        return initialState;
    },
    getters,
    actions,
});
